import isUUID from 'validator/lib/isUUID';
import uuidv4 from 'uuid/v4';
import ky from 'ky';

import extendOrSetCookie from './extendOrSetCookie';
import getGeneralFields from './getGeneralFields';

import {
  TRACKING_COOKIE_AGE__CLIENT_AGE,
  TRACKING_COOKIE_AGE__SESSION_AGE,
  TRACKING_EVENT__INIT_SESSION,
  TRACKING_OPERATION__SYSCTL,
} from './constants';

/**
 * 送出其他事件前，嘗試延長 session 效期；
 * 如果 session 不存在則生成新的，並發送 init_session 事件
 */
export default async function extendOrInitSession() {
  // 延長 installation_id 效期
  extendOrSetCookie(process.env.TRACKING_COOKIE_KEY__CLIENT_ID, {
    shouldExtend: isUUID,
    getNewValue: uuidv4,
    cookieAttributes: {
      expires: TRACKING_COOKIE_AGE__CLIENT_AGE,
      domain: process.env.TRACKING_COOKIE_DOMAIN,
    },
  });

  // 延長 session_id 效期
  const updateSessionResult = extendOrSetCookie(process.env.TRACKING_COOKIE_KEY__SESSION_ID, {
    shouldExtend: isUUID,
    getNewValue: uuidv4,
    cookieAttributes: {
      expires: TRACKING_COOKIE_AGE__SESSION_AGE,
      domain: process.env.TRACKING_COOKIE_DOMAIN,
    },
  });

  // 發送 init_session 事件
  if (!updateSessionResult.isExtended && updateSessionResult.value) {
    /** @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=744606520} */
    const payload = {
      ...(await getGeneralFields()),
      event: TRACKING_EVENT__INIT_SESSION,
      op: TRACKING_OPERATION__SYSCTL,
      op_meta: {
        language: navigator.language || navigator.userLanguage,
        width: screen.width,
        height: screen.height,
        // dpi: undefined,
        // brand: undefined,
        // model: undefined,

        user_agent: navigator.userAgent,
        // carrier: undefined,
        // connection: undefined,
      },
    };

    await ky.post(`${process.env.TRACKING_API_HOST}/v1/event`, { json: payload, throwHttpErrors: false });
  }
}
